import {Query} from './query';
import {Criterion} from './criterion';

export class Criteria {

  operator: string;
  private criteria: Criterion[];

  constructor(operator: string) {
    this.operator = operator;
    this.criteria = [];
  }

  clear() {
    this.criteria.length = 0;
  }

  isEmpty(): boolean {
    return this.criteria.length === 0;
  }

  and(criterion: Criterion): Criteria {
    this.criteria.push(criterion);
    criterion.operator = Query.AND;
    return this;
  }

  or(criterion: Criterion): Criteria {
    this.criteria.push(criterion);
    criterion.operator = Query.OR;
    return this;
  }

  findCriterion(critName: String): Criterion {
    const criterion = this.criteria.find(crit => crit.fieldName === critName);
    if (criterion != null) {
      return criterion;
    }
    return null;
  }

  public getCriteria(): Criterion[] {
    return this.criteria;
  }
}
